import { Inject, Injectable, Injector, PLATFORM_ID } from '@angular/core';
import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import { CookieService } from "ngx-cookie-service";
import { Encrypt } from "../encrypt/encrypt";
import { environment } from '@env/environment';

@Injectable({
  providedIn: 'root',
})
export class CookieCiencuadras {
  static readonly COOKIE_ESTATE_IDS = 'estateIds';
  static readonly COOKIE_CITY = 'city';
  static readonly COOKIE_TYPE_PROPERTY = 'typeProperty';
  static readonly COOKIE_TYPE_TRANSACTION = 'typeTransaction';
  static readonly COOKIE_LOCATION = 'location';
  static readonly COOKIE_NEIGHBORHOOD = 'neighborhood ';
  static readonly COOKIE_DEPARTMENT = 'department ';
  static readonly COOKIE_POPUP_MAP = 'popupMap';
  static readonly COOKIE_FULL_MAP = 'fullMap';
  static readonly COOKIE_CITY_LOCATION = 'cityLocation';
  static readonly COOKIE_ID_LEAD_FERIA = 'idLeadFeria';
  static readonly COOKIE_LATITUDE = 'lat';
  static readonly COOKIE_LONGITUDE = 'lng';
  static readonly COOKIE_VIEWTYPE = 'viewType';
  static readonly COOKIE_USERTYPE = 'userType';
  static readonly COOKIE_MODAL_MATCHMAKER = 'modalMatchmaker';
  static readonly COOKIE_TRANSACTION_TYPE_HEADER = 'transactionTypeHeader';
  static readonly COOKIE_REAL_ESTATE_ID_TO_COMPARE = 'realEstateIdToCompare';
  static readonly COOKIE_STATE_PROYECT = 'StateProyect';
  static readonly COOKIE_CONTACT_NAME = 'contactName';
  static readonly COOKIE_CONTACT_EMAIL = 'contacteEmail';
  static readonly COOKIE_CONTACT_PHONE = 'contactPhone';
  static readonly COOKIE_USER_EMAIL = 'userEmail';
  static readonly COOKIE_CONTACT_PHONE_USER_LOGGED = 'contactPhoneUserLogged';
  static readonly COOKIE_CONTACT_PROPERTY_TYPE = 'contactPropertyType';
  static readonly COOKIE_IS_HOME_PROPERTY = 'isHomeProperty';
  static readonly COOKIE_IS_DELETED_PROPERTY = 'isDeletedProperty';
  static readonly COOKIE_OBJECT_SEARCH_FILTER = 'objectFilterSearch';
  static readonly COOKIE_NAME_SEARCH_FILTER = 'nameSearch';
  static readonly COOKIE_DFAVORITE = 'dFavorite';
  static readonly COOKIE_CURRENTUSER = 'currentUser';
  static readonly COOKIE_USERNAME = 'username';
  static readonly COOKIE_IDENTIFICATION = 'user_cc';
  static readonly COOKIE_REGISTERED = 'registered';
  static readonly COOKIE_LAST_URL_404 = 'lastUrl404';
  static readonly COOKIE_USER_IDENTIFICATION = 'userIdentification';
  static readonly COOKIE_IP_ADDRESS = 'ipAddress';
  static readonly COOKIE_ID_USER = 'idUser';

  isBrowser: boolean;

  constructor(
    @Inject(PLATFORM_ID) platformId: Object,
    private injector: Injector,
    private cookieService: CookieService,
    private utils: Encrypt,
  ) {
    this.isBrowser = isPlatformBrowser(platformId);
    this.initCookiePopupMap();
  }

  public getCookie(keyCookie: string): string {
    let __cookie: any;
    if (this.isBrowser) {
      //is browser
      __cookie = this.cookieService.get(keyCookie);
    } else {
      // is server
      const req = this.injector.get('request');
      let _cookie = <string>req.headers['cookie'];
      if (_cookie) {
        let _arrayCookie = _cookie.split(';');
        for (let c of _arrayCookie) {
          let _compare = c.trim().substring(0, keyCookie.length);
          if (_compare === keyCookie) {
            __cookie = c.trim().substring(keyCookie.length + 1);
            break;
          }
        }
      }
    }
    return __cookie;
  }

  public getCookieCrypt(keyCookie: string): string {
    let __cookie: any;
    if (this.isBrowser) {
      //is browser
      __cookie = this.cookieService.get(keyCookie);
      if (__cookie) {
        __cookie = this.utils.decryptData(__cookie);
      }
    } else {
      // is server
      const req = this.injector.get('request');
      let _cookie = <string>req.headers['cookie'];
      if (_cookie) {
        let _arrayCookie = _cookie.split(';');
        for (let c of _arrayCookie) {
          let _compare = c.trim().substring(0, keyCookie.length);
          if (_compare === keyCookie) {
            __cookie = c.trim().substring(keyCookie.length + 1);
            break;
          }
        }
      }
    }
    return __cookie;
  }

  public setCookie(keyCookie: string, value: string, expires?: any): void {
    if (this.isBrowser) {
      if (expires == undefined) {
        expires = Date.now();
      }
      this.cookieService.set(keyCookie, value, expires, '/', '', true, 'Lax');
    }
  }

  public setCookieCrypt(keyCookie: string, value: string, expires?: any): void {
    let __cookie: any;
    if (this.isBrowser) {
      const isSecure = location.protocol === 'https:';
      const domain = !isSecure
        ? undefined
        : environment.environmenturl.split('//')[1].replace(/\/$/, '');
      __cookie = this.utils.encryptData(value);
      this.cookieService.set(
        keyCookie,
        __cookie,
        expires,
        '/',
        domain,
        isSecure,
        'Lax',
      );
    }
  }

  public removeAll(): void {
    if (this.isBrowser) {
      this.cookieService.delete(CookieCiencuadras.COOKIE_CITY, '/');
      this.cookieService.delete(CookieCiencuadras.COOKIE_TYPE_PROPERTY, '/');
      this.cookieService.delete(CookieCiencuadras.COOKIE_TYPE_TRANSACTION, '/');
      this.cookieService.delete(CookieCiencuadras.COOKIE_LOCATION, '/');
      this.cookieService.delete(CookieCiencuadras.COOKIE_NEIGHBORHOOD, '/');
      this.cookieService.delete(CookieCiencuadras.COOKIE_DEPARTMENT, '/');
    }
  }

  public removeCookie(keyCookie: string): void {
    if (this.isBrowser) {
      this.cookieService.delete(keyCookie, '/');
    }
  }

  public initCookieFullMap() {
    let _fullMap = this.getCookie(CookieCiencuadras.COOKIE_FULL_MAP);
    if (!_fullMap) this.setCookie(CookieCiencuadras.COOKIE_FULL_MAP, '0');
  }

  public initCookiePopupMap() {
    let _popupMap = this.getCookie(CookieCiencuadras.COOKIE_POPUP_MAP);
    if (!_popupMap) this.setCookie(CookieCiencuadras.COOKIE_POPUP_MAP, '1');
  }
}
